import { getSelectorRoot } from 'utils/selectors';

const getRaceData = getSelectorRoot('raceData');

export const getUpcomingData = getRaceData('upcomingData');
export const getUpcomingGamesIdsUsingAdditionalData = getRaceData(
  'upcomingGamesIdsUsingAdditionalData'
);
export const getHorseGamesAdditionalData = getRaceData(
  'horseGamesAdditionalData'
);
export const getCompetitionData = getRaceData('competitionData');
export const getGame = getRaceData('gameData');
export const getStoredGameIds = getRaceData('storedGameIds');
export const getEachWayPartnerTerms = getRaceData('eachWayTerms');
export const getDateAndSportFilterActiveTab = getRaceData(
  'dateAndSportFilterActiveTab'
);
export const getIsCompetitionsLoading = getRaceData('isCompetitionsLoading');
export const getIsUpcomingRacesLoading = getRaceData('isUpcomingRacesLoading');
export const getGameFromActiveTab = getRaceData('gameFromActiveTab');
export const getIsCheckGameStartTs = getRaceData('isCheckGameStartTs');
export const getIsCheckCompetition = getRaceData('isCheckCompetition');
export const getResultsTimeFilterActiveTab = getRaceData(
  'resultsTimeFilterActiveTab'
);
export const getResultsCompetitionData = getRaceData('resultsCompetitionData');
export const getIsResultsCompetitionDataLoading = getRaceData(
  'isResultsCompetitionDataLoading'
);
export const geTRacingResultsGameData = getRaceData('resultsSingleGameData');
